import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_CO_OPERATION_REQUEST, UPDATE_CO_OPERATIONS_STATUS_REQUEST } from "./constants";
import { Action, CooperationState } from "./types";

function item(state: CooperationState = {}, action: Action): CooperationState {
  switch (action.type) {
    case getSuccessActionType(FETCH_CO_OPERATION_REQUEST):
      return action.payload;

    case getSuccessActionType(UPDATE_CO_OPERATIONS_STATUS_REQUEST):
      return {
        ...state,
        status: state.id === action.payload.id ? action.payload.status : state.status,
      };

    case getFailureActionType(UPDATE_CO_OPERATIONS_STATUS_REQUEST):
      return {
        ...state,
      };

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_CO_OPERATION_REQUEST:
      return true;
    case getSuccessActionType(FETCH_CO_OPERATION_REQUEST):
    case getFailureActionType(FETCH_CO_OPERATION_REQUEST):
      return false;

    default:
      return state;
  }
}

export const cooperation = combineReducers({ item, isFetching });
